import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import { clearModal } from '@shoflo/studio-redux/actions';
import { uploadBackground } from 'actions/Broadcast';

import ModalHeader from 'components/Modal/Header';
import { BACKGROUND_FORM } from 'constants/ModalTypes';
import { LayerForm } from '@shoflo/polymer';

const BackgroundForm = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === BACKGROUND_FORM
  );
  const header = 'Upload a background image';
  const dispatch = useDispatch();

  const clearThisModal = () => dispatch(clearModal(BACKGROUND_FORM));

  const handleSubmit = source => {
    dispatch(uploadBackground(source));
    dispatch(clearModal(BACKGROUND_FORM));
  };

  return (
    <Modal isOpen={isOpen} toggle={clearThisModal}>
      <ModalHeader>{header}</ModalHeader>
      <ModalBody>
        <LayerForm
          type="background"
          onSubmit={handleSubmit}
          onCancel={clearThisModal}
          supportedFileTypes={
            'jpeg, png, gif (5mb per file size limit)\nImages can be no larger than 1920x1080 px.'
          }
        />
      </ModalBody>
    </Modal>
  );
};

export default BackgroundForm;
